import { useEffect, useState } from 'react'
import useMutationObserver from 'plugin-mantine-resources/src/hooks/useMutationObserver'

type Theme = 'light' | 'dark'

const useThemeListener = (): { theme: Theme } => {
    const [theme, setTheme] = useState<Theme>('light')

    const normalizeTheme = (theme: string): Theme => {
        if (theme == null) return 'light'
        if (theme === 'dark') return 'dark'
        if (theme === 'light') return 'light'

        return (theme.split('-')?.[1] ?? 'light') as Theme
    }

    useEffect(() => {
        const startTheme = document.getElementsByTagName('html').item(0)?.getAttribute('data-theme')
        setTheme(normalizeTheme(startTheme))
    }, [])

    useMutationObserver(
        document.documentElement,
        (mutations: MutationRecord[]) => {
            mutations.forEach((mutation: MutationRecord) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
                    const target = mutation.target as HTMLElement
                    const newColorScheme = target.getAttribute('data-theme')
                    setTheme(normalizeTheme(newColorScheme))
                }
            })
        },
        { attributes: true, subtree: true }
    )

    return { theme }
}

export default useThemeListener
